export type Nullable<T> = T | null;

export const MS_GRAPH_V1_URI = 'https://graph.microsoft.com/v1.0';
